import { createModule } from '~/factories/store'
import actions from '~/store/modules/shared/qna/actions'
import mutations from '~/store/modules/shared/qna/mutations'
import state from '~/store/modules/shared/qna/state'

export default createModule({
  actions,
  mutations,
  state
})
